export { default as Web3ModalProvider } from './Web3ModalProvider';
